import { HowMuchDoYouDrinkAlcohol } from "~/providers/utils/types/rawResponsesTypes";

export const formatHowMuchAlcohol = (answer: HowMuchDoYouDrinkAlcohol[]) =>
  answer.flatMap(({ how_much, how_many_days_a_week }) => [
    `How much? ${how_much}`,
    `How many days a week? ${how_many_days_a_week}`,
  ]);
